import { render, staticRenderFns } from "./SixthSection.vue?vue&type=template&id=0ab4a257&scoped=true&"
import script from "./SixthSection.vue?vue&type=script&lang=js&"
export * from "./SixthSection.vue?vue&type=script&lang=js&"
import style0 from "./SixthSection.vue?vue&type=style&index=0&id=0ab4a257&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab4a257",
  null
  
)

export default component.exports